export const CREDENTIAL_LOGIN_ROUTES = {
  entry: '/login',
} as const;

/** @deprecated Backend auth2 may still redirect here; route alias forwards to office365 callback. */
export const LEGACY_OAUTH_CALLBACK_PATH = '/callback' as const;

export const FEDERATED_AUTH_ROUTES = {
  office365: {
    login: '/auth/office365/login',
    callback: '/auth/office365/callback',
  },
} as const;
